import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        // Use setTimeout to ensure the scroll happens after the component has rendered
        const scrollToTop = () => {
            // Try multiple scroll methods to ensure compatibility
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant"
            });
            
            // Fallback for document.documentElement
            document.documentElement.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant"
            });
            
            // Additional fallback for document.body
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        };

        // Small delay to ensure DOM is ready
        setTimeout(scrollToTop, 0);
    }, [pathname]);

    return null;
}
